module.exports = __webpack_public_path__ + "media/reservoir.7e95b5cd.ogg";